export const TOURS_AND_HINTS = 'TOURS_AND_HINTS'
export const SEEN_PAGE_TOUR = 'SEEN_{route_name}_TOUR'
export const CLOSED_PAGE_HINT = 'CLOSED_{route_name}_HINTS'
